import apiCalls from "src/api/apiCalls";
import apiCallsForBlades from "./apiCallsForBlades";

export const getAnalyticsYearLu = async (controller) => {
    try {
        const response = await apiCallsForBlades.analyticsYearsLu(`${controller}`);
        if (response.status === 200) {
            return { data: response.data, error: '' }
        }
        return { data: null, error: apiCalls.isErrorDispaly(response) }

    } catch (error) {
        return { data: null, error: apiCalls.isErrorDispaly(error) }
    }
}
export const getAnalyticsExperience = async (controller,year) => {
    try {
        const response = await apiCallsForBlades.analyticsExperience(`${controller}`,year);
        if (response.status === 200) {
            return { data: response.data, error: '' }
        }
        return { data: null, error: apiCalls.isErrorDispaly(response) }

    } catch (error) {
        return { data: null, error: apiCalls.isErrorDispaly(error) }
    }
}
export const getAnalyticsMovementChart = async (controller,year) => {
    try {
        const response = await apiCallsForBlades.analyticsMovementChart(`${controller}`,year);
        if (response.status === 200) {
            return { data: response.data, error: '' }
        }
        return { data: null, error: apiCalls.isErrorDispaly(response) }

    } catch (error) {
        return { data: null, error: apiCalls.isErrorDispaly(error) }
    }
}